import { all, call } from 'redux-saga/effects';
import {
    fetchProjectDetails,
    fetchStagingData,
    fetchProjectData,
    fetchMerging,
    fetchDeleteAvatar,
    fetchNodeInfo,
    fetchFeatures,
    fetchLoginNumbers,
    fetchDepartments,
    fetchCommits,
    fetchStatus,
    fetchChat,
    fetchKnowladgeGraphDiff,
    fetchOrchestrationTriggerEtl,
    fetchInFlowTransfer,
    fetchknowledgeGraphMerge,
    fetchCommitHistory,
    fetchUserSettingsFilePath,
    fetchUserSettingsAllFilePath,
    fetchProjectFeatureList,
    fetchProjectFeatureListPost,
    fetchDashboardStatusBar,
    fetchAnalyzerPassengers,
    fetchUserSettingsAddProjectPath,
    fetchUserSettingsProjectPath,
    fetchScriptUpdate,
    fetchMoving,
    fetchPackageDetails,
} from './sagas';
import fetchLouncherInstaller from './downloadLouncerInstallerSaga';

export default function* rootSaga() {
    yield all([
        call(fetchProjectDetails),
        call(fetchProjectData),
        call(fetchStagingData),
        call(fetchMerging),
        call(fetchMoving),
        call(fetchDeleteAvatar),
        call(fetchNodeInfo),
        call(fetchLouncherInstaller),
        call(fetchFeatures),
        call(fetchLoginNumbers),
        call(fetchDepartments),
        call(fetchCommits),
        call(fetchStatus),
        call(fetchChat),
        call(fetchKnowladgeGraphDiff),
        call(fetchOrchestrationTriggerEtl),
        call(fetchInFlowTransfer),
        call(fetchknowledgeGraphMerge),
        call(fetchCommitHistory),
        call(fetchUserSettingsFilePath),
        call(fetchUserSettingsAllFilePath),
        call(fetchProjectFeatureList),
        call(fetchProjectFeatureListPost),
        call(fetchDashboardStatusBar),
        call(fetchAnalyzerPassengers),
        call(fetchUserSettingsAddProjectPath),
        call(fetchUserSettingsProjectPath),
        call(fetchScriptUpdate),
        call(fetchPackageDetails)
    ]);
}
